import { SVGProps } from "react"

const CalendarIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.66797 6.83325H14.3346V13.8333C14.3346 14.0101 14.2644 14.1796 14.1394 14.3047C14.0143 14.4297 13.8448 14.4999 13.668 14.4999H2.33464C2.15782 14.4999 1.98826 14.4297 1.86323 14.3047C1.73821 14.1796 1.66797 14.0101 1.66797 13.8333V6.83325Z"
      stroke="#AEAFB4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.66797 3.49992C1.66797 3.32311 1.73821 3.15354 1.86323 3.02851C1.98826 2.90349 2.15782 2.83325 2.33464 2.83325H13.668C13.8448 2.83325 14.0143 2.90349 14.1394 3.02851C14.2644 3.15354 14.3346 3.32311 14.3346 3.49992V6.83325H1.66797V3.49992Z"
      stroke="#AEAFB4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.33203 1.83325V4.49992"
      stroke="#AEAFB4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.668 1.83325V4.49992"
      stroke="#AEAFB4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.33203 11.8333H11.332"
      stroke="#AEAFB4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.66797 11.8333H6.66797"
      stroke="#AEAFB4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.33203 9.16675H11.332"
      stroke="#AEAFB4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.66797 9.16675H6.66797"
      stroke="#AEAFB4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default CalendarIcon
